var chunkToChildrenMap = {
	"28": [
		35,
		294,
		756,
		530,
		415,
		366,
		136,
		43,
		628,
		885,
		42
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));